import { render } from "./HourGlassLoader.vue?vue&type=template&id=45b2c7ea&scoped=true"
import script from "./HourGlassLoader.vue?vue&type=script&lang=js"
export * from "./HourGlassLoader.vue?vue&type=script&lang=js"

import "./HourGlassLoader.vue?vue&type=style&index=0&id=45b2c7ea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45b2c7ea"]])

export default __exports__